import { deleteOffer, patchPublishCourse, patchPublishTest, patchPublishOffers, patchPublishStudyMaterials, patchPublishVideoResource, storeSpecificCourseData, getCoursesCategoriesForNotifications, getCoursesSubCategoriesForNotification, getAutocompleteSearchForNotification, setCourseNotificationParams, getCourseDashboardData } from 'actions/courseManagement';
import { Modal, Select, Switch, Checkbox, Row, Col } from 'antd'
import { Button } from 'components/Button';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import confirmIllustration from "../../Assets/common/confirmIllustration.svg";
import Xmark from "../../Assets/common/Xmark.svg";
import downArrow from "../../Assets/common/downArrow.svg";
import { CheckOutlined, SearchOutlined } from '@ant-design/icons';
import { fetchClassList } from 'actions/schedule';

function ConfirmPublishOrUnpublishModal({
    isConfirmPublishModalVisible,
    setIsConfirmPublishModalVisible,
    setSelectedPublishCards,
    setSelectedUnpublishCards,
    selectedPublishCards,
    selectedUnpublishCards,
    togglePageLoader,
    getTotalCoursesList,
    getOnlineTestSeries,
    patchPublishCourse,
    patchPublishTest,
    fromCourseDetailsPage,
    specificCourseDataContainer,
    courseTypeName,
    patchPublishStudyMaterials,
    getStudyMaterialsList,
    patchPublishVideoResource,
    getTotalsVideoResource,
    publish,
    isFromOffersDelete,
    isFromOffersGetPage,
    selectedOfferId,
    deleteOffer,
    getOffers,
    isOffersPublishedClicked,
    isNew,
    patchPublishOffers,
    published,
    isSearchedSuggestionClicked,
    searchSelectedCourseType,
    getSearchResultsData,
    getSpecificCourseData,
    getSpecificSMData,
    getOnlineTestSeriesCourseDetails,
    getSpecificVideoCourseData,
    fromEditCoursePage,
    storeSpecificCourseData,
    postCreateOffers,
    selectedCourseType,
    selectedCategories,
    selectedSubcategories,
    clearValues,
    selectedCourse,
    fromMarketPlaceMenu,
    setRenderPage,
    renderPage,
    setHoveredCardId,
    getCoursesCategoriesForNotifications,setCourseNotificationParams,
    getCoursesSubCategoriesForNotification, autocompleteSearchData, fetchClassList, classList,
    courseCategoryData, courseSubCategoriesData, getAutocompleteSearchForNotification,
    getCourseDashboardData,courseDashboardData,courseNotificationParam
}) {
    const handleCancel = () => {
        setIsConfirmPublishModalVisible(false)
        if(!fromCourseDetailsPage){
            setHoveredCardId(null)
        }
        if (!fromCourseDetailsPage && !isFromOffersDelete && !fromEditCoursePage) {
            setSelectedUnpublishCards([]);
            setSelectedPublishCards([]);
        } else { }
    }
    const [btnLoader, setBtnLoader] = useState(false);
    const [isEnabled, setIsEnabled] = useState(true);
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedBatches, setSelectedBatches] = useState([]);
    const [updatedClassList, setUpdatedClassList] = useState([]);
    const [type, setType] = useState('allStudents');

    let showPublish = false;
    if ((isOffersPublishedClicked && isNew || isOffersPublishedClicked && !isNew && !published)) {
        showPublish = true
    } else if (fromCourseDetailsPage && publish) {
        showPublish = true
    } else if (fromCourseDetailsPage && !publish) {
        showPublish = false
    } else if (selectedPublishCards?.length != 0) {
        showPublish = false
    } else if (selectedUnpublishCards?.length != 0) {
        showPublish = true
    } else if (specificCourseDataContainer?.published != 1) {
        showPublish = true
    }
    
    const options = [
        courseDashboardData?.overview?.some(item => item?.overviewType == "liveCourse") && { label: "Live courses", value: "course" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "videoResource") && { label: "Video resources", value: "videoResource" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "testSeries") && { label: "Online test series", value: "testSeries" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "studyMaterial") &&  { label: "Study materials", value: "studyMaterial" },
        
    ].filter(Boolean);

    const handleChange = (checkedValues) => {
            setCheckedItems(checkedValues);  
    };
    useEffect(() => {
        getCoursesCategoriesForNotifications()
        getCoursesSubCategoriesForNotification()
        getAutocompleteSearchForNotification(null, () => { })
        fetchClassList('', null)
        getCourseDashboardData(()=>{})
    }, [])

    useEffect(()=>{
        setCourseNotificationParams({'isEnabled':isEnabled,'type':type,'selectedBatches':selectedBatches,'selectedCategory':selectedCategory,'selectedSubCategory':selectedSubCategory,'selectedCourses':selectedCourses,'courseTypes':checkedItems})
    },[type, selectedBatches,selectedCategory,selectedSubCategory,selectedCourses,checkedItems,isEnabled])


    

    useEffect(() => {
        setUpdatedClassList(classList.map(({ section,std, ...rest }) => ({
            ...rest,
            name: `${std} - ${section}` // Rename 'section' to 'name'
        })))
    }, [])

    const handleChangeCategories = (value) => {
        const selectedCourse = courseCategoryData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeSubCategories = (value) => {
        const selectedCourse = courseSubCategoriesData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedSubCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedSubCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeCourses = (value) => {
        const selectedCourse = autocompleteSearchData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCourses.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCourses(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleChangeBatches = (value) => {
        const selectedCourse = updatedClassList.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedBatches.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedBatches(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleRemoveCategory = (courseId) => {
        setSelectedCategory(selectedCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveSubCategory = (courseId) => {
        setSelectedSubCategory(selectedSubCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveCourses = (courseId) => {
        setSelectedCourses(selectedCourses.filter(course => course.id !== courseId));
    };
    const handleRemoveBatches = (courseId) => {
        setSelectedBatches(selectedBatches.filter(course => course.id !== courseId));
    };
    const history = useHistory();
    const actionMessage = fromEditCoursePage ? "discard changes" : (isFromOffersDelete && !isOffersPublishedClicked) ? "delete" : showPublish ? "publish" : "unpublish";
    const hasNoFeeData =
        (courseTypeName === "liveCourses" && !specificCourseDataContainer?.course?.amount) ||
        (courseTypeName === "onlineTestSeries" && !specificCourseDataContainer?.testSeriesDetails?.amount) ||
        ((courseTypeName === "studyMaterials" || courseTypeName === "videoResources") && !specificCourseDataContainer?.amount);

    const isPublishingFreeCourse = fromCourseDetailsPage && showPublish && hasNoFeeData;
    const isDisabled =  showPublish && !(
        !isEnabled || 
        type === 'allStudents' || 
        (type === 'course' && selectedCourses.length > 0) || 
        (type === 'batch' && selectedBatches.length > 0) || 
        (type === 'courseType' && checkedItems.length > 0) || 
        (type === 'courseCategory' && selectedCategory.length > 0) || 
        (type === 'courseSubcategory' && selectedSubCategory.length > 0)
      );

  
      
    return (
        <Modal
            centered
            className="modal-round-corner"
            visible={isConfirmPublishModalVisible}
            onCancel={handleCancel}
            onOk={handleCancel}
            footer={null}
            closable={false}>


            <div style={{ display: 'flex', justifyContent: 'flex-end', }} ><img style={{ cursor: 'pointer' }} src={Xmark} onClick={() => { handleCancel() }} /></div>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}><img src={confirmIllustration} /></div>
            <div style={{ fontSize: "20px", color: "#191919", fontWeight: "bold", display: "flex", justifyContent: "center" }}>Confirm</div>
            <center style={{ color: "#636363", fontSize: 16, marginTop: 5, padding: "0px 20px", fontFamily: "Roboto, sans-serif", }}> {isPublishingFreeCourse ? "Are you sure you want to publish this course for free? If not, please enter fee details first and then publish it." : `Are you sure you want to ${actionMessage} ?`} </center>

            {
                showPublish &&
                <div style={{ marginTop: 25, display: 'flex', justifyContent: 'space-between', padding: '0px 20px', alignItems: 'center' }}>
                    <div style={{ color: "#636363", fontFamily: "Roboto, sans-serif", }}>Would you like to send push notifications to students?</div>
                    <div>
                        <Switch
                            checked={isEnabled}
                            onChange={(checked) => setIsEnabled(checked)}
                            style={{ background: isEnabled ? "#594099" : "#D9D9D9" }}
                        />
                    </div>
                </div>
            }

            {
                showPublish && isEnabled &&
                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Send push notifications to <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            // placeholder="Select plan"
                            value={type}
                            onChange={(e) => {
                                setType(e)
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                        >
                            <Option value="allStudents">All students</Option>
                            <Option value="batch">Batch</Option>
                            <Option value="course">Course</Option>
                            <Option value="courseType">Course type</Option>
                            <Option value="courseCategory">Course category</Option>
                            <Option value="courseSubcategory">Course subcategory</Option>
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                </div>
            }

            {
                showPublish && isEnabled &&  type === 'courseType' && (
                    <div style={{ marginLeft: 20, marginTop: 20 }}>
                        <Checkbox.Group value={checkedItems} onChange={handleChange}>
                            <Row gutter={[20, 10]} style={{ fontFamily: "Roboto, sans-serif" }}>
                                {options.map((option) => (
                                    <Col key={option.value} xs={24} sm={12} md={12}> {/* 2 items per row */}
                                        <Checkbox
                                            value={option.value}
                                            style={{
                                                color: "#636363",
                                                fontSize: 16,
                                                width:200
                                            }}
                                        >
                                            {option.label}
                                        </Checkbox>
                                    </Col>
                                ))}
                            </Row>
                        </Checkbox.Group>
                    </div>
                )
            }

            {
                showPublish && isEnabled && type == 'courseCategory' &&

                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select course categories <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: Marketing, Cloud computing etc.
                                </span>
                            }

                            onChange={(value) => {
                       
                                handleChangeCategories(value);
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching category found"
                        >
                            {courseCategoryData.map((course) => {
                                const isSelected = selectedCategory.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                           
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedCategory.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveCategory(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }

            {
                showPublish && isEnabled && type == 'courseSubcategory' &&

                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select course subcategory <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: Marketing, Cloud computing etc.
                                </span>
                            }

                            onChange={(value) => {
                               
                                handleChangeSubCategories(value);
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching subcategoryy found"
                        >
                            {courseSubCategoriesData.map((course) => {
                                const isSelected = selectedSubCategory.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                            
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedSubCategory.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveSubCategory(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }

            {
                showPublish && isEnabled && type == 'course' &&
                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select course name <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: JEE main 2025 etc.
                                </span>
                            }

                            onChange={(value) => {
                               
                                handleChangeCourses(value);
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching course found"
                        >
                            {autocompleteSearchData.map((course) => {
                                const isSelected = selectedCourses.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                            
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedCourses.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveCourses(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }

            {
                showPublish && isEnabled && type == 'batch' &&
                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select batch <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: JEE batch 2025 etc.
                                </span>
                            }

                            onChange={(value) => {
                               
                                handleChangeBatches(value);
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching batch found"
                        >
                            {updatedClassList.map((course) => {
                                const isSelected = selectedBatches.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                           
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedBatches.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveBatches(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }
            <center>
                <div style={{ display: "flex", justifyContent: "space-around", width: "75%", marginTop: 60 }}>
                    <Button onClick={() => {
                        if (isPublishingFreeCourse) {
                            handleCancel();
                            history.push('/fee-details');
                        } else {
                            handleCancel();
                        }
                    }}>NO</Button>
                    <Button
                        type="primary"
                        loading={btnLoader}
                        disabled={isDisabled}
                        onClick={() => {
                            
                            setBtnLoader(true);
                            if (fromEditCoursePage) {
                                storeSpecificCourseData([])
                                setIsConfirmPublishModalVisible(false)
                                togglePageLoader(true)
                                if (courseTypeName == "liveCourses") {
                                    getSpecificCourseData(() => { togglePageLoader(false) })
                                } else if (courseTypeName == "videoResources") {
                                    getSpecificVideoCourseData(() => { togglePageLoader(false) })
                                } else if (courseTypeName == "studyMaterials") {
                                    getSpecificSMData(() => { togglePageLoader(false) })
                                } else if (courseTypeName == "onlineTestSeries") {
                                    getOnlineTestSeriesCourseDetails(() => { togglePageLoader(false) })
                                }
                            } else if (isFromOffersDelete && !isOffersPublishedClicked) {
                                deleteOffer(
                                    selectedOfferId,
                                    () => { setBtnLoader(false) },
                                    () => {
                                        handleCancel();
                                        if (!isFromOffersGetPage) {
                                            history.push("/offers")
                                        } else {
                                            togglePageLoader(true);
                                            getOffers(1, () => { togglePageLoader(false) })
                                        }
                                    }
                                )
                            } else if ((isOffersPublishedClicked && isNew || isOffersPublishedClicked && !isNew && !published)) {
                                postCreateOffers(
                                    true,
                                    selectedCourseType,
                                    selectedCategories,
                                    selectedSubcategories,
                                    selectedCourse,
                                    () => { setBtnLoader(false) },
                                    () => { handleCancel(); clearValues(); history.push("/offers") }
                                )
                            } else if (isOffersPublishedClicked && published) {
                                patchPublishOffers(
                                    selectedOfferId,
                                    showPublish,
                                    () => { setBtnLoader(false) },
                                    () => {
                                        handleCancel();
                                        history.push("/offers")
                                    }
                                )
                            } else if ((isSearchedSuggestionClicked && searchSelectedCourseType == "searchCourse")) {
                                patchPublishCourse(
                                    selectedPublishCards?.length != 0 ? selectedPublishCards : selectedUnpublishCards,
                                    showPublish,
                                    () => { setBtnLoader(false) },
                                    () => {
                                        handleCancel();
                                        togglePageLoader(true);
                                        getSearchResultsData(() => { togglePageLoader(false) })
                                    }
                                )
                            } else if ((isSearchedSuggestionClicked && searchSelectedCourseType == "searchStudyMaterial")) {
                                patchPublishStudyMaterials(
                                    selectedPublishCards?.length != 0 ? selectedPublishCards : selectedUnpublishCards,
                                    showPublish,
                                    () => { setBtnLoader(false) },
                                    () => {
                                        handleCancel();
                                        togglePageLoader(true);
                                        getSearchResultsData(() => { togglePageLoader(false) })
                                    }
                                )
                            } else if ((isSearchedSuggestionClicked && searchSelectedCourseType == "searchVideo")) {
                                patchPublishVideoResource(
                                    selectedPublishCards?.length != 0 ? selectedPublishCards : selectedUnpublishCards,
                                    showPublish,
                                    () => { setBtnLoader(false) },
                                    () => {
                                        handleCancel();
                                        togglePageLoader(true);
                                        getSearchResultsData(() => { togglePageLoader(false) })
                                    }
                                )
                            }
                            else if (courseTypeName == "liveCourses") {
                                patchPublishCourse(
                                    fromCourseDetailsPage || fromMarketPlaceMenu ? [specificCourseDataContainer?.course?.id || specificCourseDataContainer?.id] : selectedPublishCards?.length != 0 ? selectedPublishCards : selectedUnpublishCards, showPublish,
                                    () => { setBtnLoader(false), fromMarketPlaceMenu ? setRenderPage(!renderPage) : null },
                                    () => {
                                        handleCancel();
                                        togglePageLoader(true);
                                        if (fromCourseDetailsPage) {
                                            getSpecificCourseData(() => { togglePageLoader(false) })
                                        } else {
                                            getTotalCoursesList(() => { togglePageLoader(false) })
                                        }
                                    }
                                )
                                if (fromCourseDetailsPage) {
                                    getSpecificCourseData(() => { togglePageLoader(false) })
                                }

                            } else if (courseTypeName == "onlineTestSeries" || (isSearchedSuggestionClicked && searchSelectedCourseType == "searchTests")) {

                                patchPublishTest(
                                    fromCourseDetailsPage || fromMarketPlaceMenu ? [specificCourseDataContainer?.testSeriesDetails?.id] : selectedPublishCards?.length != 0 ? selectedPublishCards : selectedUnpublishCards,
                                    showPublish,
                                    () => { setBtnLoader(false), fromMarketPlaceMenu ? setRenderPage(!renderPage) : null },
                                    () => {
                                        handleCancel();
                                        togglePageLoader(true);
                                        if (fromCourseDetailsPage) {
                                            getOnlineTestSeriesCourseDetails(() => { togglePageLoader(false); fromMarketPlaceMenu ? setRenderPage(!renderPage) : null })
                                        } else {

                                            getOnlineTestSeries(() => togglePageLoader(false))
                                        }
                                    }
                                )
                                if (fromCourseDetailsPage) {
                                    getOnlineTestSeriesCourseDetails(() => { togglePageLoader(false); fromMarketPlaceMenu ? setRenderPage(!renderPage) : null })
                                }


                            } else if (courseTypeName == "studyMaterials" || (isSearchedSuggestionClicked && searchSelectedCourseType == "searchStudyMaterial")) {
                                patchPublishStudyMaterials(
                                    fromCourseDetailsPage || fromMarketPlaceMenu ? [specificCourseDataContainer?.id] : selectedPublishCards?.length != 0 ? selectedPublishCards : selectedUnpublishCards,
                                    showPublish,
                                    () => { setBtnLoader(false), fromMarketPlaceMenu ? setRenderPage(!renderPage) : null },
                                    () => {
                                        handleCancel();
                                        togglePageLoader(true);
                                        if (fromCourseDetailsPage) {
                                            getSpecificSMData(() => { togglePageLoader(false) })
                                        } else {
                                            getStudyMaterialsList(() => { togglePageLoader(false) })
                                        }
                                    }
                                )
                                if (fromCourseDetailsPage) {
                                    getSpecificSMData(() => { togglePageLoader(false) })
                                }
                            } else if (courseTypeName == "videoResources" || (isSearchedSuggestionClicked && searchSelectedCourseType == "searchVideo")) {
                               

                                patchPublishVideoResource(
                                    fromCourseDetailsPage || fromMarketPlaceMenu ? [specificCourseDataContainer?.id] : selectedPublishCards?.length != 0 ? selectedPublishCards : selectedUnpublishCards,
                                    showPublish,
                                    () => { setBtnLoader(false), fromMarketPlaceMenu ? setRenderPage(!renderPage) : null },
                                    () => {
                                        handleCancel();
                                        togglePageLoader(true);
                                        if (fromCourseDetailsPage) {
                                            getSpecificVideoCourseData(() => { togglePageLoader(false) })
                                        } else {
                                            getTotalsVideoResource(() => { togglePageLoader(false) })
                                        }
                                    }
                                )
                                if (fromCourseDetailsPage) {
                                    getSpecificVideoCourseData(() => { togglePageLoader(false) })
                                }
                            }
                        }}>YES</Button>
                </div>
            </center>
        </Modal>
    )
}
const mapStateToProps = (state) => {
    const { courseCategoryData, courseSubCategoriesData, autocompleteSearchData,courseNotificationParam,courseDashboardData } = state.courseManagement
    const { classList } = state.schedule
    return {
        courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList,courseNotificationParam,courseDashboardData
    };
};

const mapDispatchToProps = (dispatch) => ({
    patchPublishCourse: (ids, publish, callBack, successCallBack) => dispatch(patchPublishCourse(ids, publish, callBack, successCallBack)),
    patchPublishTest: (ids, publish, callBack, successCallBack) => dispatch(patchPublishTest(ids, publish, callBack, successCallBack)),
    patchPublishStudyMaterials: (ids, publish, callBack, successCallBack) => dispatch(patchPublishStudyMaterials(ids, publish, callBack, successCallBack)),
    patchPublishVideoResource: (ids, isPublish, callBack, successCallBack) => dispatch(patchPublishVideoResource(ids, isPublish, callBack, successCallBack)),
    deleteOffer: (id, callBack, successCallBack) => dispatch(deleteOffer(id, callBack, successCallBack)),
    patchPublishOffers: (id, publish, callBack, successCallBack) => dispatch(patchPublishOffers(id, publish, callBack, successCallBack)),
    storeSpecificCourseData: (val) => dispatch(storeSpecificCourseData(val)),
    setCourseNotificationParams: (val) => dispatch(setCourseNotificationParams(val)),
    getCoursesCategoriesForNotifications: () => dispatch(getCoursesCategoriesForNotifications()),
    getCoursesSubCategoriesForNotification: () => dispatch(getCoursesSubCategoriesForNotification()),
    getAutocompleteSearchForNotification: (search, callBack) => dispatch(getAutocompleteSearchForNotification(search, callBack)),
    fetchClassList: (search, subId, callback) => dispatch(fetchClassList(search, subId, callback)),
    getCourseDashboardData: (callBack) => dispatch(getCourseDashboardData(callBack)),

});
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPublishOrUnpublishModal);